import {
  CONTENT_SEPARATOR,
  DETAILS_CONTENT_KEYS,
  IPlanContent,
  PLAN_DETAILS_PLAN_PERIOD,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
} from '../typings';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import {
  businessDualKeyDetailsAddons,
  defaultBusinessGasDetailsAddons,
  defaultEstimatesDialog,
} from './common/planDefaults';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';

export const originBusinessSunshineSpecial: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Sunshine Special']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue:
              PLAN_DETAILS_PLAN_PERIOD.Months12 +
              CONTENT_SEPARATOR +
              PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription: '12 month benefit period',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: businessDualKeyDetailsAddons,
        gas: defaultBusinessGasDetailsAddons,
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/spot-illustrations/spot_sunshine-time.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-business-sunshine-special_elec.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-business-sunshine-special_dual.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Special electricity rates between 10am and 3pm, 7 days a week.',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/business-sunshine-special/',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
  },
};
